import { Module } from "wrapper6";
import { ga_read_more } from "../utils/_ga";

/* global jQuery */

export default class Foldout extends Module {
    ready() {
        let target = typeof window.location.href.split('#',2)[1] === 'string' ? window.location.href.split('#',2)[1] : '';
        if(target.indexOf('=') >= 0) target = "";
        if(target.indexOf('utm') === 0) target = ""; // ignore
        if(
            (
                jQuery('body').hasClass('single-course') ||
                jQuery('body').hasClass('single-education') ||
                jQuery('body').hasClass('single-e-learning')
            ) &&
            jQuery('.widget_siteorigin-panels-builder').length > 0 &&
            jQuery('.widget_siteorigin-panels-builder').height() > 600 &&
            jQuery("#"+target).length < 1
        ){
            jQuery('.widget_siteorigin-panels-builder').addClass('foldable');
            jQuery('.widget_siteorigin-panels-builder').append('<button class=\'button blue fold-out\'>Læs mere</button>');
            jQuery(".foldable .fold-out").on('click',function(e){
                let btn = jQuery(e.target);
                btn.closest(".foldable").addClass('open');
                btn.hide();
                ga_read_more();
            });
            if(jQuery(".foldable").length >= 1){
                jQuery(".course-nav a").on('click',function(){
                    jQuery(".foldable").addClass('open');
                    jQuery(".foldable").find('.fold-out').hide();
                    ga_read_more();
                });
            }
        }
    }
}